import { FC, useCallback, useEffect, useState } from 'react'
import { PhoneSpecs } from '../../phones'
import { Box } from '../index'
import { PhoneCard } from './phone-card'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { PhoneAllCard } from './phone-all-card'
import { useSelector } from 'react-redux'
import { selectScenarioType } from '../../state'
import { ScenarioType } from '../../state/interfaces'

export interface PhoneListProps {
  phones: PhoneSpecs[]
  onClick: (modelId: PhoneSpecs['modelId'] | string) => void
}

export const LAZY_LOAD_ITEMS_SIZE = 12

const calculateCursorIndex = ({ phones, startingAt = 0 }: { phones: PhoneSpecs[]; startingAt?: number }) =>
  Math.min(startingAt + LAZY_LOAD_ITEMS_SIZE, phones.length)

export const PhoneList: FC<PhoneListProps> = ({ phones, onClick }) => {
  const { t } = useTranslation()
  const [cursorIndex, setCursorIndex] = useState(calculateCursorIndex({ phones }))
  const scenarioType = useSelector(selectScenarioType)

  const displayedPhones = phones
    .map((phone, index) => <PhoneCard key={`${phone.modelSlug}-${index}`} phone={phone} onClick={onClick} />)
    .splice(0, cursorIndex)

  if (scenarioType === ScenarioType.PHONE_SEARCH && displayedPhones.length > 1) {
    displayedPhones.unshift(<PhoneAllCard key="phone-all-card" phones={'nc'} onClick={onClick} />)
  }

  const noPhonesMessage = useCallback(() => {
    if (displayedPhones.length) {
      return null
    }

    return (
      <Box layerStyle={'error'}>
        <Text>{t('error_no-devices-found')}</Text>
        <Text>{t('error_please-go-back') as string}</Text>
      </Box>
    )
  }, [t, displayedPhones])

  useEffect(() => {
    setCursorIndex(calculateCursorIndex({ phones, startingAt: LAZY_LOAD_ITEMS_SIZE }))
  }, [phones])

  return (
    <Box marginTop={4}>
      {noPhonesMessage()}

      <InfiniteScroll
        dataLength={displayedPhones.length}
        next={() => {
          setCursorIndex(calculateCursorIndex({ phones, startingAt: cursorIndex }))
        }}
        hasMore={cursorIndex < phones.length && phones.length > LAZY_LOAD_ITEMS_SIZE}
        loader={<h4>Loading...</h4>}
      >
        <Flex marginTop={4} flexWrap="wrap" justifyContent="center">
          {displayedPhones}
        </Flex>
      </InfiniteScroll>
    </Box>
  )
}
